export type Rgb = readonly [r: number, g: number, b: number]
export type Palette = readonly Rgb[]

/** Season 1: a cozy winter town. Index 0 is night, 7 is snow, 8 is lamp light. */
export const SEASON_1_PALETTE: Palette = [
  [20, 24, 46], // 0 night
  [63, 44, 40], // 1 soil
  [36, 78, 62], // 2 pine
  [168, 62, 58], // 3 brick
  [150, 102, 64], // 4 wood
  [112, 118, 134], // 5 stone
  [176, 182, 196], // 6 ash
  [244, 246, 250], // 7 snow
  [255, 212, 96], // 8 lamp
  [238, 136, 62], // 9 ember
  [140, 196, 104], // 10 moss
  [96, 160, 220], // 11 sky
  [170, 220, 240], // 12 ice
  [128, 110, 170], // 13 dusk
  [236, 140, 170], // 14 blossom
  [250, 226, 196], // 15 cream
]

export const SEASON_1_PALETTE_NAMES: readonly string[] = [
  'night',
  'soil',
  'pine',
  'brick',
  'wood',
  'stone',
  'ash',
  'snow',
  'lamp',
  'ember',
  'moss',
  'sky',
  'ice',
  'dusk',
  'blossom',
  'cream',
]

export const paletteToCss = (palette: Palette): string[] =>
  palette.map(([r, g, b]) => `rgb(${r} ${g} ${b})`)
